import { Box, Grid, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AdjustIcon from "@mui/icons-material/Adjust";
import React from "react";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import moment from "moment";

const OrderCard = ({ item, order }) => {
  const expectedDate = moment(order.orderDate)
    .add(7, "days")
    .format("dddd, MMMM Do YYYY, h:mm:ss a");
  const confirmDate = moment(order.confirmDate).format(
    "dddd, MMMM Do YYYY, h:mm:ss A"
  );
  const orderDate = moment(order.orderDate).format("dddd, MMMM Do YYYY");
  const shippingDate = moment(order.shippingDate).format("dddd, MMMM Do YYYY");
  const deliveryDate = moment(order.deliveryDate).format("dddd, MMMM Do YYYY");

  const navigate = useNavigate();
  return (
    <Box className="p-5 shadow-sm hover:shadow-md border ">
      <Grid spacing={2} container sx={{ justifyContent: "space-between" }}>
        <Grid item xs={9} sm={6}>
          <div
            onClick={() => navigate(`/account/order/${order?._id}/${item._id}`)}
            className="flex cursor-pointer"
          >
            <img
              className="w-[5rem] h-[5rem] object-cover object-top"
              src={`${item.product?.images[0]}`}
              alt=""
            />
            <div className="ml-5">
              <p className="mb-2">{item?.product?.title}</p>
              <p className="opacity-50 text-xs font-semibold space-x-5">
                <span>Size: {item?.size}</span>
              </p>
              <p className="opacity-50 text-xs font-semibold">
                <span>Color: {item?.product?.color}</span>
              </p>
              <p className="opacity-50 text-xs font-semibold">
                <span>Order Date: {orderDate}</span>
              </p>
              {order.orderStatus == "CONFIRMED" && (
                <p className="opacity-50 text-xs font-semibold">
                  <span>Confirm Date: {confirmDate}</span>
                </p>
              )}
              {order.orderStatus == "SHIPPED" && (
                <p className="opacity-50 text-xs font-semibold">
                  <span>Shipping Date: {shippingDate}</span>
                </p>
              )}

              <p className="opacity-50 text-xs font-semibold space-x-5">
                Qty: {item.quantity}
              </p>
            </div>
          </div>
        </Grid>

        <Grid item xs={3} sm={2}>
          <p>₹{item?.discountedPrice}</p>
        </Grid>
        <Grid item xs={12} sm={4}>
          <p className="space-y-2 font-sm text-sm">
            {order?.orderStatus === "DELIVERED" ? (
              <>
                <FiberManualRecordIcon
                  sx={{ width: "15px", height: "15px" }}
                  className="text-green-600 p-0 mr-2 text-sm"
                />
                <span>Delivered On {deliveryDate}</span>
              </>
            ) : (
              <>
                <AdjustIcon
                  sx={{ width: "15px", height: "15px" }}
                  className="text-green-600 p-0 mr-2 text-sm"
                />
                <span>Expected Delivery On {expectedDate}</span>
              </>
            )}
            <p className="text-xs">Your Item Has Been {order.orderStatus}</p>
          </p>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderCard;
